import { FontIcon } from '../FontIcon';
import withResponsiveStyles, { ResponsiveValue } from '../hocs/ResponiseStyles/withResponsiveStyles';
import styles from './avatar.module.sass';
import cn from 'classnames';

interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
    color?: string;
    image?: string;
    name?: string;
    description?: string | React.ReactNode;
    dimension?: 'small' | 'medium' | 'large' | 'unequal';
    border?: boolean;
    currentRestriction?: string;
    variant?: 'inline' | 'header';
    width?: ResponsiveValue;
    locked?: boolean;
    edit?: boolean;
}

const OriginalAvatar = ({
    color,
    image,
    name,
    description,
    dimension,
    border,
    currentRestriction,
    variant,
    width,
    locked,
    edit = false,
    ...props
}: AvatarProps) => {
    return (
        <div
            {...props}
            className={cn(styles.holder, variant && styles[`${variant}`])}
            {...(props.onClick && { style: { cursor: 'pointer' } })}
        >
            <div
                className={cn(
                    styles.avatar,
                    border && styles.border,
                    dimension && styles[`size-${dimension}`],
                    props.className
                )}
                style={{ backgroundImage: `url(${image})`, backgroundColor: color }}
            >
                {edit && (
                    <span className={styles.edit}>
                        <FontIcon name="pencil" size="x-small" md="x-small" />
                    </span>
                )}
            </div>
            {name && (
                <strong className={styles.name}>
                    {name}
                    {variant === 'header' && description && <span className={styles.description}>{description}</span>}
                </strong>
            )}
            {description && variant !== 'header' && <span className={styles.description}>{description}</span>}
            {currentRestriction && <span className={styles.restrict}>{currentRestriction}</span>}
            {locked && <FontIcon name="lock" size="smaller" md="smaller" className={styles.locked} />}
        </div>
    );
};

const Avatar = withResponsiveStyles(OriginalAvatar);
// Export the enhanced components
export { Avatar };
